





















































































import { getSubscriptionDiscounts } from '@front/common/endpoints'
import { RichTranslation } from '@front/common/i18n'
import { Item, Pet } from '@front/common/types'
import { formatQuantity, isKibblesItem } from '@front/common/utils'
import { Badge, Button, Typography, TYPOGRAPHY_TYPES } from '@front/ui'
import {
  defineComponent,
  onBeforeMount,
  ref,
  PropType,
} from '@vue/composition-api'

import Link from '@member-area/components/Link.vue'
import useSubscription from '@member-area/core/resources/Subscription/Subscription.hook'
import {
  MEMBER_AREA_ROUTE_PETS,
  MEMBER_AREA_ROUTE_PET_PRODUCTS,
} from '@member-area/core/routes-names'

export default defineComponent({
  components: {
    Badge,
    Button,
    Typography,
    RichTranslation,
    Link,
  },
  props: {
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
    pet: {
      type: Object as PropType<Pet>,
      required: true,
    },
    deliveryFrequency: {
      type: Number,
      default: 0,
    },
    editionAllowed: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { subscription } = useSubscription()
    const currentDiscounts = ref()

    function getItemLabel(item) {
      return (
        (item.recipe && item.recipe.marketLabel) ||
        item.article?.label ||
        item.translationKeys.title ||
        'Goodie'
      )
    }

    onBeforeMount(async () => {
      currentDiscounts.value = await getSubscriptionDiscounts(
        subscription.value.id,
      )
    })

    return {
      TYPOGRAPHY_TYPES,
      formatQuantity,
      isKibblesItem,
      getItemLabel,
      MEMBER_AREA_ROUTE_PET_PRODUCTS,
      MEMBER_AREA_ROUTE_PETS,
    }
  },
})
